export interface Category {
  id: string;
  label: string;
  emoji: string;
  dot: string;
  bg: string;
  text: string;
}

export const CATEGORIES: Category[] = [
  { id: "ANSIEDAD",              label: "Ansiedad",    emoji: "😮‍💨", dot: "#C98B6B", bg: "#F4E7DC", text: "#BC7550" },
  { id: "DEPRESIÓN",             label: "Depresión",   emoji: "💙",   dot: "#7E96A8", bg: "#EAF0F4", text: "#4F6B7D" },
  { id: "AUTOESTIMA",            label: "Autoestima",  emoji: "🌸",   dot: "#C9A86B", bg: "#F5EEDC", text: "#93702E" },
  { id: "RELACIONES",            label: "Relaciones",  emoji: "❤️",   dot: "#C98B6B", bg: "#F4E7DC", text: "#BC7550" },
  { id: "ESTRÉS",                label: "Estrés",      emoji: "🌊",   dot: "#A88BB0", bg: "#F1EAF3", text: "#7D5A87" },
  { id: "DUELO",                 label: "Duelo",       emoji: "🕊️",  dot: "#8FA8A0", bg: "#E7EEEC", text: "#5E7D73" },
  { id: "TRAUMA",                label: "Trauma",      emoji: "🌿",   dot: "#B98A6B", bg: "#F2E7DC", text: "#8C6748" },
  { id: "MINDFULNESS",           label: "Mindfulness", emoji: "🧘",   dot: "#9CB89F", bg: "#E9F0E6", text: "#5E8068" },
  { id: "LÍMITES",               label: "Límites",     emoji: "🛡️",  dot: "#C9A86B", bg: "#F5EEDC", text: "#93702E" },
  { id: "CRECIMIENTO PERSONAL",  label: "Crecimiento", emoji: "🌱",   dot: "#8FA8A0", bg: "#E7EEEC", text: "#5E7D73" },
];

const BY_ID: Record<string, Category> = Object.fromEntries(CATEGORIES.map((c) => [c.id, c]));

const FALLBACK: Category = { id: "", label: "General", emoji: "💬", dot: "#BC7550", bg: "#F4E7DC", text: "#BC7550" };

export function getCategory(id: string | undefined | null): Category {
  if (!id) return FALLBACK;
  return BY_ID[id.toUpperCase()] ?? { ...FALLBACK, id, label: id };
}

/** Convierte un slug de URL (ej. "crecimiento-personal") al id de categoría ("CRECIMIENTO PERSONAL") */
export function slugToCategoryId(slug: string): string {
  return slug.toUpperCase().replace(/-/g, " ");
}

export function categoryIdToSlug(id: string): string {
  return id.toLowerCase().replace(/ /g, "-");
}
